import { render, staticRenderFns } from "./AsideApp.vue?vue&type=template&id=58e1767f&"
import script from "./AsideApp.vue?vue&type=script&lang=js&"
export * from "./AsideApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports